<template>
  <div class="fee-detail">
    <!-- 查询区（与订单推广明细共用） -->
    <promotion-search-bar ref="searchBar" :export-api="exportPromotionFeeDetailList" @search="onSearch"></promotion-search-bar>
    <!-- 推广费分配明细列表 -->
    <el-card shadow="never">
      <el-table v-loading="tableLoading" :data="tableData" size="small" stripe style="width: 100%">
        <el-table-column label="订单号" prop="orderId" min-width="200" align="center"></el-table-column>
        <el-table-column label="订单时间" prop="orderTime" min-width="160" align="center"></el-table-column>
        <el-table-column label="订单实付金额" prop="orderAmount" min-width="110" align="center"></el-table-column>
        <el-table-column label="推广人比例" prop="promoterRate" min-width="100" align="center" :formatter="formatRate"></el-table-column>
        <el-table-column label="订单推广费" prop="promotionFee" min-width="110" align="center"></el-table-column>
        <el-table-column label="推广类型" prop="promotionTypeName" min-width="100" align="center"></el-table-column>
        <el-table-column label="交易类型" prop="tradeTypeName" min-width="100" align="center"></el-table-column>
        <el-table-column label="推广人收益" prop="promoterIncome" min-width="110" align="center"></el-table-column>
        <el-table-column label="所属油站" prop="gasName" min-width="130" align="center"></el-table-column>
        <el-table-column label="所属商户" prop="companyName" min-width="170" align="center"></el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="pageChange"
          :current-page="pagination.pageIndex"
          :page-sizes="pageSizes"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRow">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryPromotionFeeDetailList, exportPromotionFeeDetailList } from '@/api/promotionManage'
import PromotionSearchBar from '../components/promotionSearchBar'


export default {
  name: 'promotionFeeDetailTab',
  components: {
    PromotionSearchBar
  },
  data () {
    return {
      exportPromotionFeeDetailList,
      tableLoading: false,
      tableData: [],
      totalRow: 0,
      lastSearchParams: {},
      activatedReady: false,
      pagination: {
        pageIndex: 1,
        pageSize: 10
      },
      pageSizes: [10, 50, 100, 200]
    }
  },
  activated () {
    // 父级“推广费分配明细”菜单会被 keep-alive 缓存，返回该tab时需要用当前筛选条件重新查询。
    if (!this.activatedReady) {
      this.activatedReady = true
      return
    }
    this.$nextTick(async () => {
      if (this.$refs.searchBar) {
        await this.$refs.searchBar.initOptions()
        this.$refs.searchBar.search()
      } else {
        this.refresh()
      }
    })
  },
  methods: {
    isSuccess (code) {
      return code === 0 || code === 200
    },
    refreshAfterAuthenticated () {
      this.$nextTick(async () => {
        if (!this.$refs.searchBar) return
        await this.$refs.searchBar.initOptions()
        this.$refs.searchBar.search()
      })
    },
    // 查询区触发查询
    onSearch (params) {
      this.lastSearchParams = params
      this.pagination.pageIndex = 1
      this.refresh()
    },
    // 分页页码改变
    pageChange (currentPage) {
      this.pagination.pageIndex = currentPage
      this.refresh()
    },
    // 分页条数改变
    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageIndex = 1
      this.refresh()
    },
    buildQueryParams () {
      // 后端分页字段为 pageNum/pageSize，页面分页组件仍保留项目常用的 pageIndex。
      return {
        ...this.lastSearchParams,
        pageNum: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize
      }
    },
    normalizeRow (item) {
      // 表格列沿用页面通用字段名；这里把推广费分配明细接口字段转换为展示字段。
      // orderCommissionAmout 是接口文档中的字段名，同时兼容可能修正后的 orderCommissionAmount。
      return {
        ...item,
        promoterName: item.promoterName || item.distributorName,
        orderAmount: item.orderAmount || item.oilPayAmount,
        promotionFee: item.promotionFee || item.orderCommissionAmout || item.orderCommissionAmount,
        promoterRate: item.promoterRate || item.distributeRate,
        promoterIncome: item.promoterIncome || item.distributeAmount,
        orderId: item.orderId || item.orderNo,
        orderTime: item.orderTime || item.payDt,
        gasName: item.gasName || item.distributeGasName,
        companyName: item.companyName || item.distributeCompanyName,
        tradeTypeName: item.tradeTypeName || item.transactionTypeName
      }
    },
    // 获取列表数据
    async refresh () {
      this.tableLoading = true
      try {
        const params = this.buildQueryParams()
        const { code, result = [], totalRow = 0 } = await queryPromotionFeeDetailList(params)
        if (!this.isSuccess(code)) {
          this.tableData = []
          this.totalRow = 0
          return
        }
        const list = Array.isArray(result) ? result : (result.list || [])
        this.tableData = list.map(this.normalizeRow)
        this.totalRow = parseInt(totalRow || result.total || 0)
      } catch (err) {
        this.tableData = []
        this.totalRow = 0
      } finally {
        this.tableLoading = false
      }
    },
    // 推广人比例展示
    formatRate (row, column, cellValue) {
      return cellValue === null || cellValue === undefined ? '--' : `${cellValue}%`
    }
  }
}
</script>

<style lang="less" scoped>
.fee-detail {
  .pagination-wrap {
    padding: 15px 0 5px;
    text-align: right;
  }
}
</style>
